/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';
import warning from '@wordpress/warning';
const SlotFillContext = createContext({
  slots: {},
  fills: {},
  registerSlot: () => {
    typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production" ? warning('Components must be wrapped within `SlotFillProvider`. ' + 'See https://developer.wordpress.org/block-editor/components/slot-fill/') : void 0;
  },
  updateSlot: () => {},
  unregisterSlot: () => {},
  registerFill: () => {},
  unregisterFill: () => {}
});
export default SlotFillContext;
//# sourceMappingURL=slot-fill-context.js.map